module.exports = __webpack_public_path__ + "static/img/M-4.23a44d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgzgk/M-4.png
// module id = nWyv
// module chunks = 0